import type { CSSProperties } from 'react';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Skeleton: FunctionComponent<Props> = ({
    animate = true,
    className = '',
    height,
    style,
    testId = TEST_ID,
    variant = 'block',
    width = '100%'
}) => {
    const inlineStyle = {
        ...style,
        ...(width && { '--skeleton-width': width }),
        ...(height && { '--skeleton-height': height })
    } as CSSProperties;

    const staticClass = !animate ? styles.static : '';

    return (
        <span
            className={`${styles.skeleton} ${styles[`variant-${variant}`]} ${staticClass} ${className}`}
            data-testid={testId}
            style={inlineStyle}
        />
    );
};

export default Skeleton;
